const countryRates = {
  NO: {
    currency: "NOK",
    rate: 10.42,
    symbol: "kr"
  },
  US: {
    currency: "USD",
    rate: 1,
    symbol: "$"
  },
  IM: {
    currency: "GBP",
    rate: 0.76,
    symbol: "£"
  },
  CA: {
    currency: "CAD",
    rate: 1.39,
    symbol: "C$"
  },
  CH: {
    currency: "CHF",
    rate: 0.83,
    symbol: "CHF"
  },
  NZ: {
    currency: "NZD",
    rate: 1.67,
    symbol: "NZ$"
  },
  AU: {
    currency: "AUD",
    rate: 1.57,
    symbol: "A$"
  },
  AE: {
    currency: "AED",
    rate: 3.68,
    symbol: "د.إ"
  },
  NL: {
    currency: "EUR",
    rate: 0.87,
    symbol: "€"
  },
  GB: {
    currency: "GBP",
    rate: 0.76,
    symbol: "£"
  },
  IE: {
    currency: "EUR",
    rate: 0.87,
    symbol: "€"
  },
  LU: {
    currency: "EUR",
    rate: 0.87,
    symbol: "€"
  },
  DE: {
    currency: "EUR",
    rate: 0.87,
    symbol: "€"
  }
};

const allowedCountries = [
  "NO",
  "US",
  "IM",
  "CA",
  "CH",
  "NZ",
  "AU",
  "AE",
  "NL",
  "GB",
  "IE",
  "LU",
  "DE" // Germany added here
];

const countries = [
  {
    name: "Australia",
    code: "AU",
    flag: "🇦🇺"
  },
  {
    name: "Canada",
    code: "CA",
    flag: "🇨🇦"
  },
  {
    name: "Germany",
    code: "DE",
    flag: "🇩🇪"
  },
  {
    name: "Ireland",
    code: "IE",
    flag: "🇮🇪"
  },
  {
    name: "Isle of Man",
    code: "IM",
    flag: "🇮🇲"
  },
  {
    name: "Luxembourg",
    code: "LU",
    flag: "🇱🇺"
  },
  {
    name: "Netherlands",
    code: "NL",
    flag: "🇳🇱"
  },
  {
    name: "New Zealand",
    code: "NZ",
    flag: "🇳🇿"
  },
  {
    name: "Norway",
    code: "NO",
    flag: "🇳🇴"
  },
  {
    name: "Switzerland",
    code: "CH",
    flag: "🇨🇭"
  },
  {
    name: "United Arab Emirates",
    code: "AE",
    flag: "🇦🇪"
  },
  {
    name: "United Kingdom",
    code: "GB",
    flag: "🇬🇧"
  },
  {
    name: "United States",
    code: "US",
    flag: "🇺🇸"
  }
];

export { countryRates, countries, allowedCountries };
